import React from 'react';

const Page404 = props => (
  <>
    <h1>404 Pagina no encontrada ;(</h1>
  </>
)

export default Page404;